/**
 * is the color one of the default supported colors
 * used internally to determine whether a `<Box clone color={color} />` is needed or not
 * this is a hack to support e.g. `error.main` colors until material-ui v5 releases
 * it overvamped styling functionality
 */
export const isDefaultSupportedColor = (color: string) =>
  ["inherit", "default", "primary", "secondary"].includes(color);
